import { createFileRoute, redirect } from '@tanstack/react-router';
import { INVENTORY_BOOKS_ORDER_BASE_PATH } from '../../../../../../../../features/inventory/books-order/inventory-books-order-routing';

export const Route = createFileRoute('/_app/_clearing-core/_clearing-required/clearing/operations/_operations/inventory/')({
  beforeLoad: () => {
    throw redirect({ to: INVENTORY_BOOKS_ORDER_BASE_PATH });
  },
  preload: false,
});
